import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { MenuMain } from "./MenuMain";
import { MenuDay } from "./MenuDay";
import { DayFilters } from "./DayFilters";
import { DayGrid } from "./DayGrid";
import { MenuTabs } from "./MenuTabs";
import { Player } from "./Player";
import { Playlist, PlaylistTop } from './Playlist';
import { LayoutSwitcher } from "./LayoutSwitcher";
import { getDataById, getDataByUniq } from './utils';
import { Context } from '../context';

export function Layout({ playlistId, videoId }) {

  const context = useContext(Context);

  videoId = videoId || getDataById(context, 'playlists', playlistId, 'videos')

  return (
    <>
      <div className="b0">
        <MenuMain />

        <div className="c00">
          <div className="l_main0">
            <div className="l_main">


              <div className="l_playlist">
                {/* <DayFilters/> */}

                {/* <DayGrid/> */}

                {/* <LayoutSwitcher/> */}

                <div className="l_catalog">
                  <div className={`l_catalog_inner ${videoId ? 'l_catalog_inner--full' : ''}`}>

                    {playlistId && <PlaylistTop
                      {...getDataByUniq(context, "playlists", playlistId)}
                    />}

                    <Playlist playlistId={playlistId} />
                  </div>
                </div>
              </div>
                {Boolean(videoId) && <Player />}
            </div>


          </div>
        </div>
      </div>
    </>
  );
}
